import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'

import { DatePickerDialogModule } from './date-picker-dialog'
import { FileInputModule } from './file-input'
import { PaymentCardFormModule } from './payment-card-form'
import { TextDialogComponent } from './text-dialog/text-dialog.component'

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
  ],
  exports: [
    PaymentCardFormModule,
    TextDialogComponent,
    DatePickerDialogModule,
    FileInputModule,
  ],
  declarations: [
    TextDialogComponent,
  ],
})
export class ComponentsModule {}
